import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export var initialize = createAction("".concat(actionTypePrefix, "/INITIALIZE"), function (deviationId) { return ({
    deviationId: deviationId,
}); });
export var submit = createAction("".concat(actionTypePrefix, "/SUBMIT"), function (typeid, deviationId, answers) { return ({
    typeid: typeid,
    deviationId: deviationId,
    answers: answers,
}); });
export var submitSuccess = createAction("".concat(actionTypePrefix, "/SUBMIT_SUCCESS"), function () { return ({}); });
export var submitFailure = createAction("".concat(actionTypePrefix, "/SUBMIT_FAILURE"), function () { return ({}); });
export var requestSuccess = createAction("".concat(actionTypePrefix, "/REQUEST_SUCCESS"), function (deviationId, data) { return ({
    deviationId: deviationId,
    data: data,
}); });
export var requestFailure = createAction("".concat(actionTypePrefix, "/REQUEST_FAILURE"), function (deviationId) { return ({ deviationId: deviationId }); });
//# sourceMappingURL=actionCreators.js.map